module.exports = __webpack_public_path__ + "images/cross-blacka276ea2dccd0f3ce5904f80df8ebfdbd.svg";